import React, { useState, useEffect, useRef } from 'react';

const COUNTRY_OPTIONS = [
    { id: 'usa_mainland', label: 'USA Mainland' },
    { id: 'usa_with_alaska_hawaii', label: 'USA with Alaska and Hawaii' },
    { id: 'other', label: 'Other Country' },
];

export default function WizardSelectCountryForm({ onDataChange, initialData }) {
    const [selectedCountry, setSelectedCountry] = useState(initialData.selectedCountry || 'usa_mainland');
    const onDataChangeRef = useRef(onDataChange);

    // Update ref when callback changes
    useEffect(() => {
        onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    // Only call onDataChange when actual data changes
    useEffect(() => {
        if (onDataChangeRef.current) {
            onDataChangeRef.current({ selectedCountry });
        }
    }, [selectedCountry]);

    const handleCountrySelect = (countryId) => {
        setSelectedCountry(countryId);
    };

    return (
        <div className="wizard-select-country-form">
            <h2 className="wizard-step-heading">Select Country</h2>
            <div className="country-options-container">
                {COUNTRY_OPTIONS.map((country) => (
                    <div
                        key={country.id}
                        className={`country-option ${selectedCountry === country.id ? 'selected' : ''}`}
                        onClick={() => handleCountrySelect(country.id)}
                    >
                        <div className="country-option-content">
                            <span className="country-option-label">{country.label}</span>
                            <div className={`country-option-radio ${selectedCountry === country.id ? 'checked' : ''}`}>
                                {selectedCountry === country.id && <div className="radio-inner" />}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

